import { render, staticRenderFns } from "./MobileInstall.vue?vue&type=template&id=479a0b8a&scoped=true&"
var script = {}
import style0 from "./MobileInstall.vue?vue&type=style&index=0&id=479a0b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a0b8a",
  null
  
)

export default component.exports